import React, { Component } from 'react'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import {
  actionButtonsColumnProps,
  BooleanCellStatus,
  BooleanColumn,
  BooleanFilterCell,
  BsrsGrid,
  DateCell,
  DateFilterCell,
  DateTimeCell,
  DateTimeFilterCell
} from '@/components/BsrsGrid'
import context from '@/context'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { localized } from '@/decorators/localized'
import { connect } from 'react-redux'
import Icon from '@/components/Icon'
import { actionCreators } from '@/store/usersManagement'
import { FormGroup } from 'reactstrap'

const mapStateToProps = (state) => {
  return {
    resetPasswordResult: state.usersManagement.resetPasswordResult,
    lastReloadAt: state.usersManagement.lastReloadAt
  }
}

const mapDispatchToProps = {
  setUserState: actionCreators.setUserState,
  generatePasswordResetToken: actionCreators.generatePasswordResetToken,
  resetState: actionCreators.resetState
}

@localized()
@connect(mapStateToProps, mapDispatchToProps)
class UserManagementList extends Component {
  constructor (props, context) {
    super(props, context)

    props.resetState()
  }

  setUserState (e) {
    this.props.setUserState({
      id: e.id,
      stateCode: 'BlockOrActivate'
    })
  }

  generatePasswordResetToken (e) {
    this.props.generatePasswordResetToken(e.emailAddress)
  }

  getButtons = (dataItem) => {
    let sourceActionButtons = []

    sourceActionButtons.push({
      url: x => `/users/${x.id}`,
      icon: 'pencil'
    })

    if (dataItem.approvedAt !== null) {
      sourceActionButtons.push({
        icon: x => x.isActive ? 'lock-open' : 'lock',
        onConfirm: item => {
          this.setUserState(item)
        },
        confirmTitle: item => item.isActive ? 'UsersManagement.SetInactiveConfirmTitle' : 'UsersManagement.SetActiveConfirmTitle',
        confirmText: item => item.isActive ? 'UsersManagement.SetInactiveConfirmText' : 'UsersManagement.SetActiveConfirmText'
      })

      if (dataItem.isActive) {
        sourceActionButtons.push({
          icon: 'key',
          onConfirm: item => {
            this.generatePasswordResetToken(item)
          },
          confirmTitle: 'UsersManagement.ResetPasswordConfirmTitle',
          confirmText: 'UsersManagement.ResetPasswordConfirmText'
        })
      }
    }

    return sourceActionButtons
  }

  render () {
    const { localize, lastReloadAt } = this.props

    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='UsersManagement.Title' />
          </MainTopTitle>
          <MainTopLeft>
            <Link className='btn btn-primary btn-sm' to='/users/add'>
              <Icon name='plus' /> <span><Resx name='UsersManagement.CreateInstitutionAccount' /></span>
            </Link>
          </MainTopLeft>
        </MainTop>
        <MainBody clear>
          {this.renderResetPasswordResult()}
          <WhiteBox>
            <BsrsGrid persistenceId={'users'} dataSource={context.api.userManagementService.getUsers} lastReloadedAt={lastReloadAt}>
              <Column field='userName' title={localize('UsersManagement.UserName')} />
              <Column field='emailAddress' title={localize('UsersManagement.EmailAddress')} />
              <Column field='creationTime' title={localize('UsersManagement.CreationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} width='110px' />
              <Column field='lastModificationTime' title={localize('UsersManagement.LastModificationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} width='110px' />
              <Column field='lockoutEndDateUtc' title={localize('UsersManagement.LockoutEndDateUtc')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} width='110px' />
              <Column field='lastLoginTime' title={localize('UsersManagement.LastLoginTime')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} width='110px' />
              <Column field='approvedAt' title={localize('UsersManagement.ApprovedAt')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} width='110px' />
              <Column field='accessFailedCount' title={localize('UsersManagement.AccessFailedCount')} width='60px' />
              {BooleanColumn({ field: 'isTwoFactorEnabled', title: localize('UsersManagement.IsTwoFactorEnabled'), width: '60px' })}
              {BooleanColumn({ field: 'isEmailConfirmed', title: localize('UsersManagement.IsEmailConfirmed'), width: '60px' })}
              <Column field='isActive' title={localize('UsersManagement.IsActive')} cell={BooleanCellStatus} filterCell={BooleanFilterCell} width='60px' />
              <Column title={localize('UsersManagement.Action')} {...actionButtonsColumnProps(this.getButtons.bind(this))} />
            </BsrsGrid>
          </WhiteBox>
        </MainBody>
      </Main>
    )
  }

  renderResetPasswordResult () {
    const { resetPasswordResult } = this.props
    if (resetPasswordResult !== null) {
      return (
        <FormGroup>
          <Resx name='Common.GeneratePasswordResetToken' />
          {resetPasswordResult && <Resx name='Common.Success' />}
          {!resetPasswordResult && <Resx name='Common.Error' />}
        </FormGroup>
      )
    }
    return null
  }
}

export { UserManagementList }



// WEBPACK FOOTER //
// ./src/report-app/pages/usersManagement/list.js